import { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
import PeriodEducationalContent from "./PeriodEducationalContent";
const TITLE = "حاسبة الدورة الشهرية - حساب موعد الدورة القادمة بدقة";
const DESCRIPTION = "حاسبة الدورة الشهرية الدقيقة لحساب موعد الدورة القادمة وأيام التبويض. أدخلي تاريخ آخر دورة لمعرفة مواعيد الدورات القادمة وفترات الخصوبة لمدة 12 شهراً. حاسبة دورة الحيض المجانية مع تقويم شامل وشرح مفصل.";
const KEYWORDS = "حاسبة الدورة الشهرية, حساب الدورة الشهرية, حاسبة دورة الحيض, أيام التبويض, موعد الدورة القادمة, تقويم الدورة الشهرية, حساب أيام الخصوبة, period calculator, حاسبة العادة الشهرية, متى تأتي الدورة, حساب الحيض, أيام الإباضة";
const OG_URL = "https://do-calculate.com/calculator/ar/period/";

const GREGORIAN_MONTHS = [ "يناير / كانون الثاني", "فبراير / شباط", "مارس / آذار", "أبريل / نيسان", "مايو / أيار", "يونيو / حزيران", "يوليو / تموز", "أغسطس / آب", "سبتمبر / أيلول", "أكتوبر / تشرين الأول", "نوفمبر / تشرين الثاني", "ديسمبر / كانون الأول" ];
function PeriodCalculator() {
  // استبدال الحالة بمدخلات منفصلة للتاريخ
  const [dateInput, setDateInput] = useState({
    day: new Date().getDate(),
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear()
  });

  const [periodLength, setPeriodLength] = useState(5);
  const [cycleLength, setCycleLength] = useState(28);
  const [lastPeriodError, setLastPeriodError] = useState("");
  const [periodLengthError, setPeriodLengthError] = useState("");
  const [cycleLengthError, setCycleLengthError] = useState("");
  const [result, setResult] = useState(null);

  // Helper functions for date calculations
  const addDays = (date, days) => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  };

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const handleDropdownChange = (e) => {
    const { name, value } = e.target;
    const newDateInput = { ...dateInput, [name]: value };
    setDateInput(newDateInput);

    // التحقق من التاريخ
    const selectedDate = new Date(newDateInput.year, newDateInput.month - 1, newDateInput.day);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (selectedDate > today) {
      setLastPeriodError("التاريخ يجب أن يكون في الماضي");
    } else {
      const diffTime = Math.abs(today - selectedDate);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      if (diffDays > 90) {
        setLastPeriodError("التاريخ يبدو بعيداً جداً في الماضي");
      } else {
        setLastPeriodError("");
      }
    }
  };

  const handlePeriodLengthChange = (event) => {
    const value = event.target.value;
    if (value !== "") {
      const parsedValue = parseInt(value);
      if (!isNaN(parsedValue) && parsedValue >= 1 && parsedValue <= 10) {
        setPeriodLength(parsedValue);
        setPeriodLengthError("");
      } else {
        setPeriodLength(value);
        if (isNaN(parsedValue)) {
          setPeriodLengthError("تأكدي من إدخال رقم صحيح");
        } else if (parsedValue < 1) {
          setPeriodLengthError("مدة الحيض يجب أن تكون يوماً واحداً على الأقل");
        } else if (parsedValue > 10) {
          setPeriodLengthError("مدة الحيض يجب ألا تزيد عن 10 أيام");
        }
      }
    } else {
      setPeriodLength("");
      setPeriodLengthError("");
    }
  };

  const handleCycleLengthChange = (event) => {
    const value = event.target.value;
    if (value !== "") {
      const parsedValue = parseInt(value);
      if (!isNaN(parsedValue) && parsedValue >= 21 && parsedValue <= 35) {
        setCycleLength(parsedValue);
        setCycleLengthError("");
      } else {
        setCycleLength(value);
        if (isNaN(parsedValue)) {
          setCycleLengthError("تأكدي من إدخال رقم صحيح");
        } else if (parsedValue < 21) {
          setCycleLengthError("طول الدورة يجب أن يكون 21 يوماً على الأقل");
        } else if (parsedValue > 35) {
          setCycleLengthError("طول الدورة يجب ألا يزيد عن 35 يوماً");
        }
      }
    } else {
      setCycleLength("");
      setCycleLengthError("");
    }
  };

  const handleReset = () => {
    setDateInput({
      day: new Date().getDate(),
      month: new Date().getMonth() + 1,
      year: new Date().getFullYear()
    });
    setPeriodLength(5);
    setCycleLength(28);
    setLastPeriodError("");
    setPeriodLengthError("");
    setCycleLengthError("");
    setResult(null);
  };

  const calculatePeriod = (e) => {
    e.preventDefault();
    const startDate = new Date(dateInput.year, dateInput.month - 1, dateInput.day);

    if (isNaN(startDate.getTime()) || !periodLength || !cycleLength || lastPeriodError) {
      return;
    }

    const periods = [];
    for (let i = 0; i < 12; i++) {
      const periodStart = addDays(startDate, cycleLength * i);
      const periodEnd = addDays(periodStart, periodLength - 1);
      const ovulationDay = addDays(periodStart, cycleLength - 14);
      const ovulationStart = addDays(ovulationDay, -2);
      const ovulationEnd = addDays(ovulationDay, 2);
      periods.push({
        cycleNumber: i + 1,
        periodStart: formatDate(periodStart),
        periodEnd: formatDate(periodEnd),
        ovulationStart: formatDate(ovulationStart),
        ovulationEnd: formatDate(ovulationEnd),
        ovulationDay: formatDate(ovulationDay),
      });
    }
    setResult({
      periods: periods,
      cycleLength: cycleLength,
      periodLength: periodLength,
    });
  };
  // Generate Schema.org structured data
  const generateSchemaData = () => {
    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "الصفحة الرئيسية",
          item: "https://do-calculate.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "الحاسبات",
          item: "https://do-calculate.com/ar/all-calculators/",
        },
        {
          "@type": "ListItem",
          position: 3,
          name: "حاسبة الدورة الشهرية",
          item: OG_URL,
        },
      ],
    };
    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "كيف أحسب موعد الدورة الشهرية القادمة؟",
          acceptedAnswer: {
            "@type": "Answer",
            text: "لحساب موعد الدورة القادمة، أدخلي تاريخ أول يوم من آخر دورة شهرية ومتوسط طول دورتك (عادةً 28 يوماً). أضيفي عدد أيام الدورة لتحديد موعد الدورة القادمة.",
          },
        },
        {
          "@type": "Question",
          name: "ما هو طول الدورة الشهرية الطبيعي؟",
          acceptedAnswer: {
            "@type": "Answer",
            text: "طول الدورة الشهرية الطبيعي يتراوح بين 21 إلى 35 يوماً، والمتوسط 28 يوماً. أما مدة الحيض فتتراوح بين 3 إلى 7 أيام.",
          },
        },
        {
          "@type": "Question",
          name: "متى تحدث الإباضة؟",
          acceptedAnswer: {
            "@type": "Answer",
            text: "تحدث الإباضة عادةً قبل 14 يوماً من موعد الدورة القادمة. فترة الخصوبة تمتد من 5 أيام قبل الإباضة إلى يوم واحد بعدها.",
          },
        },
        {
          "@type": "Question",
          name: "ما هي علامات اقتراب الدورة الشهرية؟",
          acceptedAnswer: {
            "@type": "Answer",
            text: "علامات اقتراب الدورة تشمل: ألم أسفل البطن، تقلب المزاج، انتفاخ، ألم الثدي، تعب، تغيرات في الشهية، وظهور حب الشباب.",
          },
        },
      ],
    };
    const calculatorSchema = {
      "@context": "https://schema.org",
      "@type": "WebApplication",
      name: "حاسبة الدورة الشهرية",
      description: DESCRIPTION,
      url: OG_URL,
      applicationCategory: "HealthApplication",
      operatingSystem: "Any",
      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "USD",
      },
    };
    return [breadcrumbSchema, faqSchema, calculatorSchema];
  };
  return (
    <div className="rtl" style={{ direction: "rtl" }}>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
        SCHEMA={generateSchemaData()}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ padding: "15px", borderRadius: "12px" }}
          >
            <h1 style={{ fontSize: "22px", margin: 0 }}>{TITLE}</h1>
          </div>
          <div className="border border-light mt-3 p-3 bg-white shadow-sm">
            {/* Introduction */}
            <div className="mb-4">
              <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
                <strong>حاسبة الدورة الشهرية</strong> هي أداة مجانية ودقيقة
                لحساب <strong>موعد الدورة القادمة</strong> و
                <strong>أيام التبويض</strong> لمدة 12 شهراً قادماً. كل ما
                تحتاجينه هو إدخال تاريخ أول يوم من آخر دورة شهرية ومتوسط طول
                دورتك للحصول على تقويم شامل يوضح مواعيد{" "}
                <strong>الدورات القادمة</strong> و<strong>فترات الخصوبة</strong>{" "}
                بدقة.
              </p>
            </div>
            <hr />
            <MobileUnderCalAds />
            {/* Calculator Section */}
            <div className="row">
              <div className="col-sm-12 col-md-6 calculatorStyle">
                <div className="p-3 mb-3 bg-success text-white text-center rounded">
                  <h2 style={{ fontSize: "18px", margin: 0 }}>
                    احسبي موعد دورتك القادمة
                  </h2>
                </div>
                <form onSubmit={calculatePeriod}>
                  <div className="form-group mb-3">
                    <label >
                      <strong>أول يوم في آخر دورة شهرية:</strong>
                    </label>
                    <div className="d-flex gap-2">
                      <select style={{width:'100px'}} className="form-control" name="day" value={dateInput.day} onChange={handleDropdownChange}>
                        {Array.from({ length: 31 }, (_, i) => i + 1).map(d => <option key={d} value={d}>{d}</option>)}
                      </select>
                      <select style={{width:'100%'}} className="form-control" name="month" value={dateInput.month} onChange={handleDropdownChange}>
                        {GREGORIAN_MONTHS.map((m, i) => <option key={i + 1} value={i + 1}>{i + 1} - {m}</option>)}
                      </select>
                      <select style={{width:'100px'}} className="form-control" name="year" value={dateInput.year} onChange={handleDropdownChange}>
                        {Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i).map(y => <option key={y} value={y}>{y}</option>)}
                      </select>
                    </div>
                    {lastPeriodError && <div className="text-danger mt-1" style={{ fontSize: "14px" }}>{lastPeriodError}</div>}
                  </div>

                  <div className="form-group mb-3">
                    <label  htmlFor="periodLength">
                      <strong>مدة الحيض (كم يوماً استمرت؟):</strong>
                    </label>
                    <div className="d-flex align-items-center">
                      <input id="periodLength" type="number" className="form-control" value={periodLength} onChange={handlePeriodLengthChange} min="1" max="10" required style={{ maxWidth: "150px" }} />
                      <span style={{ marginRight: "10px", padding: "8px 15px", border: "1px solid #ced4da", borderRadius: "4px", backgroundColor: "#f9f9f9" }}>يوم</span>
                    </div>
                    {periodLengthError && <div className="text-danger mt-1" style={{ fontSize: "14px" }}>{periodLengthError}</div>}
                    <small className="form-text text-muted mt-1">المتوسط الطبيعي: 3-7 أيام</small>
                  </div>

                  <div className="form-group mb-4">
                    <label  htmlFor="cycleLength">
                      <strong>متوسط طول الدورة (الوقت بين الدورات):</strong>
                    </label>
                    <div className="d-flex align-items-center">
                      <input id="cycleLength" type="number" className="form-control" value={cycleLength} onChange={handleCycleLengthChange} min="21" max="35" required style={{ maxWidth: "150px" }} />
                      <span style={{ marginRight: "10px", padding: "8px 15px", border: "1px solid #ced4da", borderRadius: "4px", backgroundColor: "#f9f9f9" }}>يوم</span>
                    </div>
                    {cycleLengthError && <div className="text-danger mt-1" style={{ fontSize: "14px" }}>{cycleLengthError}</div>}
                    <small className="form-text text-muted mt-1">المتوسط الطبيعي: 28 يوماً (يتراوح بين 21-35 يوماً)</small>
                  </div>

                  <hr />
                  <div className="d-flex gap-2">
                    <button type="submit" className="btn bg-success text-white" style={{ fontSize: "16px", padding: "10px 30px" }}>احسب</button>
                    <button type="button" className="btn btn-secondary" onClick={handleReset} style={{ fontSize: "16px", padding: "10px 30px" , marginRight: "10px"}}>امسح</button>
                  </div>
                </form>
              </div>
              <div className="col-sm-12 col-md-6">
                {result && (
                  <div className="calculatorStyle">
                    <div className="p-3 mb-3 bg-success text-white text-center rounded">
                      <h3 style={{ fontSize: "18px", margin: 0 }}>
                        تقويم الدورة الشهرية - 12 شهراً قادماً
                      </h3>
                    </div>
                    <div
                      className="alert alert-info"
                      style={{
                        fontSize: "14px",
                        maxHeight: "500px",
                        overflowY: "auto",
                      }}
                    >
                      {result.periods.map((period, index) => (
                        <div
                          key={index}
                          style={{
                            marginBottom: "20px",
                            padding: "15px",
                            backgroundColor:
                              index % 2 === 0 ? "#f8f9fa" : "#ffffff",
                            borderRadius: "8px",
                            border: "1px solid #dee2e6",
                          }}
                        >
                          <h4
                            style={{
                              fontSize: "16px",
                              color: "#198754",
                              marginBottom: "10px",
                            }}
                          >
                            <strong>الدورة رقم {period.cycleNumber}</strong>
                          </h4>
                          <div style={{ lineHeight: "1.8" }}>
                            <div style={{ marginBottom: "5px" }}>
                              <strong>فترة الحيض:</strong>{" "}
                              {period.periodStart} - {period.periodEnd}
                            </div>
                            <div style={{ marginBottom: "5px" }}>
                              <strong>يوم التبويض:</strong>{" "}
                              {period.ovulationDay}
                            </div>
                            <div
                              style={{
                                color: "#0d6efd",
                                fontWeight: "500",
                              }}
                            >
                              <strong>فترة الخصوبة:</strong>{" "}
                              {period.ovulationStart} - {period.ovulationEnd}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div
              className="alert alert-info"
              style={{ fontSize: "15px", lineHeight: "1.8" }}
            >
              <strong>💡 ملاحظة مهمة:</strong> هذه النتائج تقديرية وتفترض أن
              دورتك منتظمة. للحصول على معلومات دقيقة عن الخصوبة والإباضة،
              يُنصح باستشارة الطبيب أو استخدام اختبارات التبويض المنزلية.
            </div>
            <hr />
            {/* Related Links */}
            <div className="row">
              <RelatedLinks />
            </div>
          </div>
        </div>
        <div className="col-sm-12 col-md-4">
          <SecondAds />
          <br />
          <MainCalculatorsList />
        </div>
      </div>
      {/* Educational Content Section */}
      <PeriodEducationalContent />
      <br />
    </div>
  );
}
export default PeriodCalculator;